// extracted by mini-css-extract-plugin
export default {"sidebar-window":"SideBar_sidebar-window__PxO32"};